import * as tslib_1 from "tslib";
import { is } from "../utilities/is-type";
import * as cache from "./cache";
import { property as defaultProperty } from "./property";
var defaultContextCreator = Object.create.bind(null, null, {});
function elementContext(creator) {
    if (creator === void 0) { creator = defaultContextCreator; }
    var context = new WeakMap();
    return function (host) {
        var value = context.get(host);
        if (!value) {
            context.set(host, (value = creator(host)));
        }
        return value;
    };
}
var ɵ0 = function () {
    return {};
};
var properties = elementContext(ɵ0);
function configure(element, key, property) {
    if (properties(element)[key]) {
        cache.invalidate(element, key, true);
    }
    properties(element)[key] = property;
    var proto = Object.getPrototypeOf(element);
    if (!(key in proto)) {
        Object.defineProperty(proto, key, {
            get: function get() {
                return cache.get(this, key, properties(this)[key].get);
            },
            set: property.set &&
                function set(newValue) {
                    cache.set(this, key, properties(this)[key].set, newValue);
                },
            enumerable: true,
            configurable: false
        });
    }
}
function element(properties) {
    return function (createElement) { return function () {
        var element = createElement();
        Object.keys(properties).forEach(function (key) {
            var property;
            var value = properties[key];
            if (is.function(value)) {
                property = { get: value };
            }
            else if (is.null(value) ||
                !is.object(value) ||
                (is.object(value) &&
                    !value.get &&
                    !value.set &&
                    !value.connect &&
                    !value.observe)) {
                property = defaultProperty(value);
            }
            else {
                value = value;
                property = {
                    get: value.get || (function (host, value) { return value; }),
                    set: value.set ||
                        (!value.get && (function (host, value) { return value; })) ||
                        undefined,
                    connect: value.connect,
                    observe: value.observe
                };
            }
            configure(element, key, property);
        });
        return element;
    }; };
}
var ɵ1 = function () { return []; };
var disconnects = elementContext(ɵ1);
function makeElement(BaseElement, init) {
    function Element() {
        // eslint-disable-next-line fp/no-this
        var el = this;
        if (!(el instanceof Element)) {
            // @ts-ignore
            return new Element();
        }
        return init.call(el, function () {
            if (typeof Reflect === "undefined") {
                return BaseElement.call(el);
            }
            return Reflect.construct(BaseElement, [], el.constructor);
        });
    }
    Element.prototype = Object.create(BaseElement.prototype);
    Element.prototype.constructor = Element;
    Element.prototype.connectedCallback = function () {
        var _this = this;
        Object.keys(properties(this)).forEach(function (key) {
            var property = properties(_this)[key];
            if (property.connect) {
                var disconnect = property.connect(_this, key, function () {
                    cache.invalidate(_this, key, false);
                });
                disconnect && disconnects(_this).push(disconnect);
            }
            if (property.observe) {
                var subscriber = cache.observe(_this, key, property.get, property.observe);
                subscriber && disconnects(_this).push(subscriber);
            }
        });
    };
    Element.prototype.disconnectedCallback = function () {
        disconnects(this).forEach(function (disconnect) { return disconnect(); });
        disconnects(this).splice(0, disconnects(this).length);
    };
    return Element;
}
function compose() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.reduce(function (prevFn, nextFn) { return function (value) { return prevFn(nextFn(value)); }; });
}
var registry = new Set();
function define(definition) {
    var enhancers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        enhancers[_i - 1] = arguments[_i];
    }
    var tagName = is.string(definition) ? definition : definition.tagName;
    var builtin = is.object(definition) ? definition.extends : undefined;
    var BaseElement = builtin ? document.createElement(builtin).constructor : HTMLElement;
    var enhancer = compose.apply(void 0, tslib_1.__spread(enhancers));
    var Element = makeElement(BaseElement, function (createElement) {
        return enhancer(createElement)();
    });
    var CustomElement = window.customElements.get(tagName);
    if (CustomElement) {
        if (registry.has(CustomElement)) {
            return;
        }
        throw Error("Element '" + tagName + "' already defined");
    }
    registry.add(Element);
    customElements.define(tagName, Element, builtin && { extends: builtin });
}
export { define, element, compose, elementContext, configure };
export { ɵ0, ɵ1 };
//# sourceMappingURL=element.js.map